module.exports = __webpack_public_path__ + "img/monitor-red.573d33df.png";